"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.apiElasticsearch_search_post = exports.api_elasticsearch_search_post_failure = exports.api_elasticsearch_search_post_success = exports.api_elasticsearch_search_post_request = exports.API_ELASTICSEARCH_SEARCH_POST_FAILURE = exports.API_ELASTICSEARCH_SEARCH_POST_SUCCESS = exports.API_ELASTICSEARCH_SEARCH_POST_REQUEST = undefined;

var _index = require("axios/index");

var _index2 = _interopRequireDefault(_index);

var _nodeToolbox = require("@esnpm/node-toolbox");

var _bluebird = require("bluebird");

var _bluebird2 = _interopRequireDefault(_bluebird);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API_ELASTICSEARCH_SEARCH_POST_REQUEST = exports.API_ELASTICSEARCH_SEARCH_POST_REQUEST = "API_ELASTICSEARCH_SEARCH_POST_REQUEST";
var API_ELASTICSEARCH_SEARCH_POST_SUCCESS = exports.API_ELASTICSEARCH_SEARCH_POST_SUCCESS = "API_ELASTICSEARCH_SEARCH_POST_SUCCESS";
var API_ELASTICSEARCH_SEARCH_POST_FAILURE = exports.API_ELASTICSEARCH_SEARCH_POST_FAILURE = "API_ELASTICSEARCH_SEARCH_POST_FAILURE";

var api_elasticsearch_search_post_request = exports.api_elasticsearch_search_post_request = function api_elasticsearch_search_post_request(options) {
	return {
		type: API_ELASTICSEARCH_SEARCH_POST_REQUEST,
		options: options,
		payload: {
			loading: true
		}
	};
};

var api_elasticsearch_search_post_success = exports.api_elasticsearch_search_post_success = function api_elasticsearch_search_post_success(data) {
	return {
		type: API_ELASTICSEARCH_SEARCH_POST_SUCCESS,
		payload: {
			loading: false,
			data: data,
			error: null
		}
	};
};

var api_elasticsearch_search_post_failure = exports.api_elasticsearch_search_post_failure = function api_elasticsearch_search_post_failure(error) {
	return {
		type: API_ELASTICSEARCH_SEARCH_POST_FAILURE,
		payload: {
			loading: false,
			error: error
		}
	};
};

/*
	Search.apiElasticsearch_search_post
	ELASTICSEARCH SEARCH is intern limited to 5000 results
	        :param q: Searchstring
	        :param SKIP: Skipped PRODUCTS
	        :param LIMIT: (SKIP+LIMIT)= AMOUNT_PRODUCTS
	        :param MAX_RESULTS:  MAX return PRODUCTS
	        :param SORT  e.g. {Sort={SKU:-1}
	        :param FILTER_CLASS:  LIST GRID or AUTO
	        :return:   ret = {
	                 "PRODUCTS": products,
	                "LIMIT": LIMIT,
	                "MAX_HIT": total,
	                "SKIP": SKIP,
	                "SORT": SORT,
	                "FILTER_CLASS": FILTER_CLASS,
	                "VIEW": VIEW
	            }
*/
var apiElasticsearch_search_post = exports.apiElasticsearch_search_post = function apiElasticsearch_search_post(options) {
	return (
		// eslint-disable-next-line no-unused-vars
		function (dispatch, getState) {
			return new _bluebird2.default(
			// eslint-disable-next-line no-unused-vars
			function (resolve, reject) {
				dispatch(api_elasticsearch_search_post_request(options));
				var url = (0, _nodeToolbox.getAPIUrl)([{ "parameters": [], "url": "/api/search" }], options);
				(0, _index2.default)({
					method: "post",
					url: url,
					params: {
						FILTER_CLASS: options.FILTER_CLASS,
						LIMIT: options.LIMIT,
						MAX_RESULTS: options.MAX_RESULTS,
						SKIP: options.SKIP,
						VIEW: options.VIEW,
						q: options.q
					},
					data: {
						SORT: options.SORT
					}
				}).then(function (response) {
					if (response.data.SUCCESSFUL) {
						dispatch(api_elasticsearch_search_post_success(response.data.DATA));
						resolve();
					} else {
						dispatch(api_elasticsearch_search_post_failure(response.data));
						resolve();
					}
				}, function (err) {
					// eslint-disable-next-line no-console
					console.log(err);
					reject();
				});
			});
		}
	);
};